import type { ReactNode } from 'react';
import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import style from './sortable-section.module.less';

type SortableSectionProps = {
  children: ReactNode;
  disabled?: boolean;
  id: string;
};

export const SortableSection = ({ id, children, disabled = false }: SortableSectionProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id, disabled });

  const isCustomizeMode = !disabled;

  const sortableStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      className={`${style['sortable-section']} ${isCustomizeMode ? style['draggable-mode'] : ''}`}
      style={sortableStyle}
      {...(isCustomizeMode ? attributes : {})}
      {...(isCustomizeMode ? listeners : {})}
    >
      <div className={`${style['sortable-section-content']} ${isCustomizeMode ? style['non-interactable'] : ''}`}>{children}</div>
    </div>
  );
};
